import { UserDTOPayoutFrequency } from "@/generated/api/models";
import { useMemo } from "react";

export function usePayoutFrequency(payoutFrequency?: UserDTOPayoutFrequency) {
  const result = useMemo(() => {
    switch (payoutFrequency) {
      case "DAILY":
        return "Daily";
      case "MONTHLY":
        return "Monthly";
      default:
      case "WEEKLY":
        return "Weekly";
    }
  }, [payoutFrequency]);

  return result;
}
